export const theme = {
    colors: {
        trovoBlue : '#004988',
        white: '#FFFFFF',
        trovoBlack: '#191919',
        trovoPowderBlue: '#ACD1EF',
        trovoNavyBlue: '#00225A',
        darkText: '#000',

    }
}